<template>
  <v-flex data-qa="consentpreview-flex-izcol">
    <Loader v-if="loaderEnabled"/>
    <Modal
    :config="getReviewConsentDetailsConfig"
    @btn1Action="onConfirmAndContinue">
    <template slot="modalContent">
        <v-row no-gutters>
        <font class="pb-2 body-2 text--secondary">
            {{ $t('termsAndConditions.reviewAndAcceptDetails') }}
        </font>
        <ul>
            <li v-for="(item, index) in consentConfig" :key="index" style="list-style-type: none">
            <span><font class="body-2 text--secondary">{{ $t('termsAndConditions.agreeLabel') }}</font>
                <a :style="{ color: primaryColor }" class="font-weight-bold" target="_blank" @click="openTermsAndConditions(item)"> {{ item.tcTypeDescription ? item.tcTypeDescription : item.tcTypeCode }}</a>
                <v-icon
                color='green'
                right
                small
                v-if="item.tcAccepted === true"
                >mdi-check</v-icon
                >
                </span>
            </li>
        </ul>
        <v-checkbox
            v-model="acceptConsentCheckbox"
            :disabled="disableConsentCheckbox"
            :color="primaryColor"
            class="body-2 text--secondary"
        > <template v-slot:label>
            <font class="body-2 text--secondary"> {{ $t('termsAndConditions.radioBoxLabel') }} </font>
            </template>
        </v-checkbox>
        </v-row>
    </template>
    </Modal>
    <ConsentPreview
    v-if="openConsentPreview"
    :consentInfo="accountConsentContent"
    @cancel="openConsentPreview=false"
    @acceptConsent="acceptConsentDetails"/>
</v-flex>
</template>

<script>
import store from '@/core/store'

export default {
  name: 'ReviewConsentDetails',
  components: {
    Loader: () => import('@/components/common/Loader.vue'),
    Modal: () => import('@/components/common/Modal.vue'),
    ConsentPreview: () => import('@/components/common/ConsentPreview.vue')
  },
  props: {
    consentConfig: {
      type: Array
    }
  },
  data () {
    return {
      loaderEnabled: false,
      acceptConsentCheckbox: false,
      openConsentPreview: false,
      enableTCForAccountOpening: this.$appSettings.defaultConfigurations.consentManagement.enableTCForAccountOpening,
      reviewConsentModalConfig: {
        enabled: true,
        persistent: true,
        close: true,
        cancelCallback: this.onCancel,
        title: this.$t('termsAndConditions.reviewAndAcceptTitle'),
        width: 600,
        btn1Label: this.$t('termsAndConditions.actions.confirmAndContinue')
      }
    }
  },
  created () {
    const { customerDetails, originalResidentialAddr } = store.getters['profileStore/profileData']
    this.customerDetails = customerDetails
    this.addressDetails = originalResidentialAddr
  },
  computed: {
    disableConsentCheckbox () {
      return !this.consentConfig.every(consent => consent.tcAccepted === true)
    },
    enableConfirmAndContinue () {
      return !(this.acceptConsentCheckbox && this.consentConfig.every(consent => consent.tcAccepted === true))
    },
    getReviewConsentDetailsConfig () {
      return {
        ...this.reviewConsentModalConfig,
        enableCancel: this.enableConfirmAndContinue
      }
    }
  },
  methods: {
    onConfirmAndContinue () {
      this.$emit('continue', this.consentConfig)
    },
    openTermsAndConditions (consentData) {
      this.accountConsentContent = consentData
      this.openConsentPreview = true
    },
    acceptConsentDetails (consent) {
      this.consentConfig.forEach(item => {
        if (item.tcTypeCode === consent.tcTypeCode) {
          this.$set(item, 'tcAccepted', true)
        }
      })
      this.reviewConsentModalConfig.enabled = true
    },
    onCancel () {
      this.$emit('cancel', true)
    }
  }
}
</script>
